export function addSelectionToList(baseArray, newItem) {
  for(let idx in baseArray) {
    if(baseArray[idx].id === newItem.id) {
      console.log("ADDED", newItem)
      baseArray[idx] = newItem
      return baseArray
    }
    else if(baseArray[idx].type == 'case-block') {
      baseArray[idx].filters = addSelectionToList(baseArray[idx].filters, newItem)
    }
  }

  return baseArray
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/addSelectionToList.js